import * as THREE from 'three'
import type { FragmentsModel } from '@thatopen/fragments'
import { viewerApi } from '@viewer/lib/viewerApi'
import type { LancarRaio } from './pinOclusao'
import type { Vec3 } from './pinCorte'

// O lançador de raios da oclusão dos pins, sobre os modelos abertos (ver
// pinOclusao.ts para o método e as regras).
//
// O raycast dos Fragments recebe o rato em coordenadas de CLIENTE (tira o
// rectângulo do canvas e normaliza), como na selecção
// (canvas/useInteraction.ts). Saltam-se os modelos escondidos pelo olho
// da árvore, como na selecção: o que não se vê não tapa.

/** O lançador para a câmara e o canvas de agora, ou null sem viewer. */
export function lancadorDaCena(): LancarRaio | null {
  const world = viewerApi.getWorld()
  const dom = world?.renderer?.three.domElement
  if (!world || !dom || typeof viewerApi.iterModels !== 'function') return null
  const camera = world.camera.three as THREE.PerspectiveCamera | THREE.OrthographicCamera
  const rect = dom.getBoundingClientRect()
  return async (pedido, todos) => {
    const mouse = new THREE.Vector2(rect.left + pedido.x, rect.top + pedido.y)
    const pontos: Vec3[] = []
    for (const [, model] of viewerApi.iterModels()) {
      const obj = (model as unknown as { object?: { visible: boolean } }).object
      if (obj && !obj.visible) continue
      const m = model as FragmentsModel
      if (todos) {
        const rs = await m.raycastAll({ camera, mouse, dom }).catch(() => null)
        for (const r of rs ?? []) pontos.push([r.point.x, r.point.y, r.point.z])
      } else {
        const r = await m.raycast({ camera, mouse, dom }).catch(() => null)
        if (r) pontos.push([r.point.x, r.point.y, r.point.z])
      }
    }
    return pontos
  }
}
